import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';

import { selectEmptyThemesRule } from '@newStore/validation/validationRules/notEmptyThemesValidationRules';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { curriculumSelectorComponent } from '@nodeTypeConfig/helpers/editComponents/curriculumSelector';
import { faqThemesComponent } from '@nodeTypeConfig/helpers/editComponents/faqThemes';
import { proThemeAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proThemeAudienceTab';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import constants from '../../../../reduxLoop/constants/constants';
import { leerplanSitesThemeComponent } from './leerplansitesGenericConfigProps';

export const SHARED_FAQ: RootNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [selectCurriculumThemesValidation],
  information: {
    definiteArticle: false,
    single: 'Gedeelde FAQ (leerplansites so)',
    plural: 'Gedeelde FAQ (leerplansites so)',
    category: 'LEERPLANSITES_SO',
  },
  onLoadActions: [loadReferenceFrame({ referenceFrame: referenceFrames.pro })],
  websiteHref: null,
  tocTypes: [],
  buildingBlocks: [
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE_GROUP },
    { type: NodeType.IMAGE },
    { type: NodeType.VIDEO },
  ],
  edit: [
    {
      ...titleComponent,
      label: 'Vraag',
    },
    {
      ...authorsComponent,
      options: {
        queryParams: constants.allAuthorsParameters,
      },
    },
    publishComponent,
    {
      ...leerplanSitesThemeComponent,
      customRequiredMessage:
        'Je moet een <strong>leerplanthema</strong> invullen. Anders verschijnt dit item niet in een FAQ-groep.',
    },
    curriculumSelectorComponent,
    {
      ...faqThemesComponent,
      validations: [selectEmptyThemesRule],
      customRequiredMessage:
        'Je moet een <strong>FAQ-groep categorie</strong> invullen. Anders verschijnt dit item niet in een FAQ-groep.',
    },
  ],
  audienceTab: proThemeAudienceTab,
  createModal: {
    title: {
      label: 'Vraag',
    },
    authors: {
      addUser: false,
      queryParams: constants.allAuthorsParameters,
    },
  },
  isCreatable: true,
  isCloneable: true,
  isSearchable: true,
  allowSuggestions: true,
};
